import { CloudProductAvailability } from "@omni/types/api/store/cloud/shared/productAvailability.model";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { StorePickerConfig } from "@/components/Store/StorePicker/types/storePickerConfig.type";
import { StorePickerType } from "@/components/Store/StorePicker/types/storePickerType.enum";
import { StoreStatus } from "@/components/Store/StoreSearch/components/list/storeCard/storeStatus/storeStatus.component";
import { TStoreStatus } from "@/components/Store/utils/storeInfo";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { StoreProductAvailabilityComponent } from "./components/storeProductAvailability/storeProductAvailability.component";

type StoreCardComponentProps = {
    storeName: string;
    isDisabled: boolean;
    isSelected: boolean;
    handleOnStoreClick: () => void;
    handleSubmit: () => void;
    storeStatus: TStoreStatus;
    statusText: string;
    address: string;
    productAvailability?: CloudProductAvailability | null;
    config: StorePickerConfig;
};

const StoreCardComponent = ({
    storeName,
    isDisabled,
    isSelected,
    handleOnStoreClick,
    handleSubmit,
    storeStatus,
    statusText,
    address,
    productAvailability,
    config
}: StoreCardComponentProps) => {
    const { t } = useGranite();

    return (
        <li
            className={cn(
                "tw:border tw:border-grey-input tw:rounded-md tw:p-2 tw:flex tw:flex-col tw:cursor-pointer tw:relative tw:overflow-hidden tw:min-h-33.75",
                {
                    "tw:bg-grey tw:border tw:border-primary":
                        isSelected && !isDisabled,
                    "tw:opacity-50 tw:text-grey-input": isDisabled,
                    "tw:hover:bg-grey": !isDisabled
                }
            )}
            onClick={handleOnStoreClick}
        >
            <p className={cn("tw:font-bold tw:text-xl")}>{storeName}</p>
            <div className={cn("tw:flex tw:justify-between tw:flex-wrap")}>
                <div className={cn("tw:flex tw:flex-col tw:mr-4")}>
                    <StoreStatus
                        isOpen={storeStatus.isOpen}
                        openClosesAt={storeStatus.text2}
                        statusText={statusText}
                    />
                    <p className={cn("tw:m-0")}>
                        <i className={cn("las la-map-marker", "tw:mr-2")} />
                        {address}
                    </p>
                    {productAvailability && (
                        <StoreProductAvailabilityComponent
                            productAvailability={productAvailability}
                        />
                    )}
                </div>

                {config.type === StorePickerType.SELECT && (
                    <div className={cn("tw:flex tw:self-end tw:mt-2")}>
                        <Button
                            onClick={handleSubmit}
                            disabled={isDisabled}
                            type={"button"}
                            fullWidth={true}
                        >
                            <strong>
                                {config.submitButtonText ||
                                    t(
                                        "general.storepicker.button.confirmStore"
                                    )}
                            </strong>
                        </Button>
                    </div>
                )}
            </div>
        </li>
    );
};

export { StoreCardComponent };
